import { combineReducers } from "redux";
import auth from "./auth";
import entities from "./entities";

const reducers = combineReducers({
  auth,
  entities,
});

export default reducers;
